module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many individuals and organizations made this book possible. The Program in Early American Economy and Society (PEAES) at the Library Company of Philadelphia (LCP), was willing to take a chance on a vague idea with a clever title back in 2002. Many thanks to PEAES director Cathy Matson and the Historical Society of Pennsylvania for providing a home during the initial year of research. LCP staff, especially Connie King and Jim Green, gave guidance, tracked down obscure sources, and referred me to a good chiropractor. Cathy Matson (who should be thanked twice) and fellow fellows at both PEAES and the McNeil Center for Early American Studies provided invaluable comments and camaraderie. Thanks to Michelle Craig McDonald, Stephen Mihm, Carl Robert Keyes, Kathleen Duval, and all who attended the joint PEAES/MCEAS seminar in Spring 2003. I will never forget Michelle’s cookies, cakes, and Cassatt House hospitality. Sean X. Goudie’s invitation to participate in the Circum-Atlantic Studies Group at Vanderbilt University in April 2003, with helpful feedback from participants Jane Landers and Daniel Usner, paved the way for publication of an initial article.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only now can I appreciate how appropriate it was to receive what may have been the last Boston Marine Society Fellowship from the Massachusetts Historical Society in 2005–2006. As the “oldest association of sea captains in the world,” the Boston Marine Society has been around since 1754, and many of its early members had connections to the post-Revolution China trade. Thanks to Conrad E. Wright, Kate Viens, and the helpful staff at MHS for making my time in Boston productive. Similarly, in 2008–2009 the Kate B. and Hall J. Peterson Fellowship administered by Paul J. Erickson, Director of Academic Programs at the American Antiquarian Society, helped uncover sources from the revolutionary period.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("More recently, colleagues and participants at the PEAES conference in ")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("October 2014, Economic History’s Many Muses, took me back to larger questions of consumer culture and economies in meaningful ways. Thanks to Seth Rockman, Ellen Hartigan-O’Connor, Danielle Skeehan, Dael Norwood, and others who are named above. The graphics department at Old Dominion University provided assistance for the maps, and colleagues in the Department of History cheered me on and cheered me up. Thanks to our Associates Reading Group, including Maura Hametz, Erin Jordan, Michael Carhart, Austin Jersild, Kathy Pearson, Martha Daas, and Heidi Schlipphacke.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, a heartfelt shout out to Dr. Claire Carman, Dr. Michael Danso, Dr. Mark Shaves, and Team Tina for attentive care; they made the final revisions possible, if not always painless. And to Bob, who made me smile, laugh, and live through it all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 78
// module chunks = 0